export interface WeatherHour {temperatureF:number|null;windMph:number|null;windFrom:number|null}
export interface WeatherCell {ring:number[][];updatedAt:string;hours:WeatherHour[]}
export interface WeatherConditions {updatedAt:string;hours:{summary:string|null;isDaytime:boolean|null}[]}
export interface MapWeather {source:string;fetchedAt:string;times:string[];bounds:[[number,number],[number,number]];cells:WeatherCell[];conditions?:WeatherConditions|null;missingCells:number}
export function conditionSymbol(summary:string|null|undefined,isDaytime:boolean|null|undefined){
 const text=summary?.toLowerCase()||'';
 if(/thunder|t-storm/.test(text))return 'storm';
 if(/freezing|sleet|ice|hail/.test(text))return 'ice';
 if(/snow|flurr/.test(text))return 'snow';
 if(/rain|shower|drizzle/.test(text))return isDaytime===false?'night-rain':'rain';
 if(/fog|mist|haze|smoke/.test(text))return 'fog';
 if(/cloud|overcast/.test(text))return isDaytime===false?'night-cloud':/partly|mostly sunny/.test(text)&&isDaytime===true?'partly-cloud':'cloud';
 if(/mostly sunny|mostly clear|partly sunny/.test(text))return isDaytime===false?'night-cloud':isDaytime===true?'partly-cloud':'unknown';
 if(/sunny|clear/.test(text))return isDaytime===false?'night':isDaytime===true?'sun':'unknown';
 return 'unknown';
}
export const windCompass=(from:number)=>['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'][Math.round(from/22.5)%16];
export type {TerrainRange} from './mapTerrainRendering.js';
export {ELEVATION_COLORS,elevationRenderingRule,terrainTileUrl,slopeRenderingRule,slopeTileUrl} from './mapTerrainRendering.js';
